import { useMemo } from "react";
import { StyleSheet } from "react-native";

const useConcatStyles = (styles: Array<any>) => {
  return useMemo(() => StyleSheet.flatten(styles), [styles]);
};

export { useConcatStyles };
